import React from 'react';
import { X, Printer } from 'lucide-react';

export default function DocumentPreview({ doc, onClose }) {
  function handlePrint() {
    const newWin = window.open('', '_blank');
    if (!newWin) {
      alert('אנא אפשר חלונות קופצים בדפדפן כדי להדפיס');
      return;
    }
    newWin.document.write(doc.rendered_html);
    newWin.document.close();
    setTimeout(() => { newWin.focus(); newWin.print(); }, 150);
  }

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl w-full max-w-4xl h-[90vh] flex flex-col">
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 dark:border-gray-700 shrink-0">
          <div>
            <h2 className="font-semibold text-gray-900 dark:text-white">{doc.template_name}</h2>
            <p className="text-xs text-gray-500 dark:text-gray-400">{doc.customer_name}</p>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={handlePrint}
              className="flex items-center gap-2 px-3 py-2 rounded-lg bg-primary-600 hover:bg-primary-700 text-white text-sm font-medium transition-colors"
            >
              <Printer size={15} />
              הדפסה
            </button>
            <button onClick={onClose}
              className="p-1.5 rounded-lg text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700">
              <X size={18} />
            </button>
          </div>
        </div>
        <iframe
          srcDoc={doc.rendered_html}
          className="flex-1 w-full rounded-b-2xl"
          title="Document Preview"
          sandbox="allow-same-origin allow-scripts"
        />
      </div>
    </div>
  );
}
